module.exports = __webpack_public_path__ + "static/media/СЗФО_2011.f01adb37.png";